import { CompassIcon } from './CompassIcon';

/**
 * author: Google
 * id 8FE64B61-0FD6-4056-9A4F-E62408CE70FE
 * name compass
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/compass.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const ExploreIcon = CompassIcon;
export default ExploreIcon